export enum ConnectionState {
    Waiting,
    Failed,
    Connected
}
